<template>
  <div
    v-if="isShowInterestForm"
    id="interestDemo"
    class="interest_demov2"
    data-stat-id="ly"
    data-stat-expose
  >
    <template v-if="isCaseInterestData">
      <section class="interest_case_data">
        <h3 class="title">
          利益演示
        </h3>
        <div class="loading">
          <i class="iconfont icon-jiazai" />
        </div>
        <div class="text">
          正在为您完善本投保方案利益数据， <br>
          预计<em>2-5分钟</em>完成....
        </div>
        <div class="card">
          可关闭当前页面，不会中断数据更新。<br>
          稍后将通过APP消息和短信等通知您更新完成。
        </div>
      </section>
    </template>
    <template v-else>
      <InterestForm
        :is-screen-capture-show="isScreenCaptureShow"
        :setting-store="settingStore"
        :interest-demo-options="interestDemoOptions"
        :init-interest-data="initInterestData"
        :form-data="curProductFormData"
        :params="{
          isForPresentation,
          uuid: params.uuid
        }"
        @open-add-and-take="onOpenAddAndTake"
        @update="update"
        @hideBonus="hideBonus"
      />
      <!-- 概览、表格模块 -->
      <!-- 由于echart渲染原因，图表模块不能用v-show，需要用v-if -->
      <template v-for="o in DISPLAY_TYPE_OPTIONS">
        <template v-if="o.key === settingStore.displayType">
          <InterestOverview
            v-if="o.key === 'Overview'"
            :key="o.key + '_overview'"
            :form-data="curProductFormData"
            :cur-product-interest-data="curProductInterestData"
            :interest-detail-with-remark="interestDetailWithRemark"
            :filter-interest-detail-data="filterInterestDetailData"
            :params="{
              uuid: params.uuid,
              insuredAge,
              insured2Age,
              period: curProductPeriod
            }"
            :is-screen-capture-show="isScreenCaptureShow"
            @openExplain="isShowKeyExplain = true"
            @update="update"
          />
          <InterestTable
            v-if="o.key === 'Table'"
            :key="o.key + '_table'"
            scene="normal"
            :person-data="personData"
            :product-form-data="curProductFormData"
            :product-interest-data="curProductInterestData"
            :product-result-data="curProductResultData"
            :interest-detail-data="interestDetailWithRemark"
            :is-screen-capture-show="isScreenCaptureShow"
            @openExplain="isShowKeyExplain = true"
            @update="update"
          />
        </template>
      </template>
      <InterestSettingPopups
        v-if="!URL_PARAM.noheader"
        ref="interestSettingPopups"
        :setting-store="settingStore"
        :result-data="initResultData && initResultData.resultData"
        :form-data="curProductFormData"
        :interest-field-options="interestFieldOptions"
        :params="{
          isForPresentation,
          uuid: params.uuid,
          insuredAge
        }"
        :interest-detail-request-params="interestDetailRequestParams"
        @update-account-map="$emit('update-account-map', $event)"
        @update="update"
      />
      <InterestKeyExplain v-model="isShowKeyExplain" :filter-interest-detail-data="filterInterestDetailData" />
    </template>
  </div>
</template>
<script>
import { get as _get, cloneDeep } from 'lodash'
import QS from 'qs'

import { initInterest, getInterestDetailWithRemark, saveShareInteraction } from '@/pages/planbkTemplatev2/js/api.js'
import { isBxs, isNuoYa } from 'base/config'
import { APP_CHANNEL, URL_PARAM } from 'common/utils/variables'
import { initSettingStore } from './handler.js'
import { DISPLAY_TYPE_OPTIONS, CACHE_DETAIL_DATA_WITH_REMARK } from './constant'

import InterestTable from '@/pages/planbkTemplatev2/components/interest-table/index.vue'
import InterestForm from './components/interest-form.vue'
import InterestOverview from './components/interest-overview.vue'
import InterestSettingPopups from './components/interest-setting-popups.vue'
import InterestKeyExplain from './components/interest-key-explain.vue'

const { pbType, shareFrom } = URL_PARAM
const BONUS_PSUDO_OPTION_CUSTOM_RATE = {
  description : '红利利益实现率',
  hiddenFlag : false,
  value : 'PSUDO_OPTION_CUSTOM_RATE'
}
const NONMAIN_CALCULATION_FIELDS = ['draw_max', 'draw_min', 'draw_left', 'draw_fee', 'take_max', 'take_min', 'take_left', 'take_fee', 'cash_flow', 'withdrawal']

export default {
  components: {
    InterestForm,
    InterestOverview,
    InterestTable,
    InterestSettingPopups,
    InterestKeyExplain
  },
  props: {
    isForPresentation: Boolean,
    isScreenCaptureShow: Boolean,
    initResultData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    personData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    params: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      isApp: (window.appBridge && window.appBridge.isApp()) || isNuoYa,
      isShowKeyExplain: false,
      settingStore: {
        displayType: '',
        activeProductId: null,
        productFormList: []
      },
      initInterestData: null,
      interestDetailData: null,
      interestDetailWithRemark: null,
      isCaseInterestData: false,
      isFirstVisit: true,
      interestDetailRequestParams: null,

      DISPLAY_TYPE_OPTIONS,
      URL_PARAM
    }
  },
  computed: {
    isShowInterestForm () {
      const { initInterestData, interestDetailData, isCaseInterestData } = this
      const hasInterestData = !!initInterestData && (initInterestData.length > 1 || !!_get(interestDetailData, 'length'))
      return isCaseInterestData || hasInterestData
    },
    resultData () {
      return this.initResultData.resultData
    },
    insuredAge () {
      return _get(this, 'personData.insuredInfo.age')
    },
    insured2Age () {
      return _get(this, 'personData.insured2Info.title') ? _get(this, 'personData.insured2Info.age') : null
    },
    curProductFormData () {
      const { settingStore, initResultData } = this
      const { activeProductId, productFormList } = settingStore
      const _curProductFormData = productFormList.find(p => p.productId === activeProductId) || productFormList[0]
      if (initResultData.interestSetting) {
        const settingForm =
          initResultData.interestSetting.productFormList.find(
            (p) => p.productId === _curProductFormData.productId
          );
        if (settingForm)
          _curProductFormData.formValues.bonus = settingForm.formValues.bonus;
      }
      return _curProductFormData
    },
    curProductResultData () {
      const { resultData, settingStore } = this
      const productGroup = resultData && resultData.productGroupList[0]
      const prodOrderList = productGroup && productGroup.prodOrderList
      const product = prodOrderList && prodOrderList.find(p => p.key === settingStore.activeProductId)
      return product
    },
    curProductPeriod () {
      const { curProductResultData } = this
      if (!curProductResultData) {
        return 0
      }
      const firstInsurance = curProductResultData.mulInsOrderList.find(ins => ins.key !== 'common')
      if (firstInsurance) {
        return firstInsurance.period
      }
      return 0
    },
    curProductInterestData () {
      return this.initInterestData && this.initInterestData.find(e => e.productId === this.settingStore.activeProductId)
    },
    filterInterestDetailData () {
      const { interestDetailData, curProductFormData } = this
      const { displayFields } = curProductFormData.formValues
      return (interestDetailData || []).filter(item => displayFields.includes(item.key))
    },
    interestDemoOptions() {
      const vm = this
      const { isApp, isForPresentation, initInterestData, settingStore, curProductResultData, curProductFormData, curProductInterestData, initResultData } = this
      const isInAppEditable = (isApp || ['WXMP', 'WXMP_BXZ', 'WECHAT_GAOKE'].includes(APP_CHANNEL)) && !isForPresentation && shareFrom !== 'mpH5ShareBtn'
      if (!curProductFormData) {
        return
      }
      const formItems = []
      if (_get(initInterestData, 'length') > 1) {
        formItems.push({
          key: 'activeProductId',
          stat: 'lycpqh',
          name: '产品',
          options: initInterestData.map(d => ({
            description: d.productName,
            value: d.productId
          }))
        })
      }

      formItems.push({
        key: 'displayAge',
        stat: 'lyxsxsxhsxx',
        name: '展示年龄',
        options: [
          { value: null, description: '全部' },
          { value: 5, description: '5岁的倍数' },
          { value: 10, description: '10岁的倍数'},
        ]
      })

      const _mulInsOrderList = _get(curProductResultData, 'mulInsOrderList') || []
      const _resultAddAndTakeIns = _mulInsOrderList.find(ins => ins.account && ins.accountData && ins.accountData.accountPart)
      const _resultReduceBaofIns = _mulInsOrderList.find(ins => ins.reduceBaof)
      const _isSupportAddAndTake = !['single_insurance', 'manual_insurance', 'noconfig_insurance', 'online_trade'].includes(_get(curProductResultData, 'policyType'))
      if (_isSupportAddAndTake && _resultAddAndTakeIns) {
        const _accountPart = _get(_resultAddAndTakeIns, 'accountData.accountPart')
        const name = {
          addAndTake: '追加领取',
          add: '追加',
          take: '领取'
        }[_accountPart]
        const _addAndTakeData = _get(curProductFormData, 'addAndTakeData.addAndTakeData') || []
        const hasAddAndTake = _addAndTakeData.some(ele => ele.adjustData && ele.adjustData.length)
        if (isInAppEditable || hasAddAndTake) {
          formItems.push({
            key: 'addAndTakeData',
            stat: 'lyzjlqqh',
            name,
            options: hasAddAndTake ? [
              { description: '追加/领取前', value: false },
              { description: '追加/领取后', value: true }
            ] : [],
            actionBtnTx: isInAppEditable ? `设置${name}` : ''
          })
        }
      }
      if (_isSupportAddAndTake && _resultReduceBaofIns) {
        const _drawData = _get(curProductFormData, 'drawData') || []
        const _duplicateDrawData = _get(curProductFormData, 'duplicateDrawData') || []
        const hasDraw = _drawData.some(ele => ele.adjustData && ele.adjustData.length) || _duplicateDrawData.some(ele => ele.adjustData && ele.adjustData.length)
        if (isInAppEditable || hasDraw) {
          formItems.push({
            key: 'drawData',
            stat: 'lyzjlqqh',
            name: '减保',
            options: hasDraw ? [
              { description: '减保前', value: false },
              { description: '减保后', value: true }
            ] : [],
            actionBtnTx: isInAppEditable ? '设置减保领取' : ''
          })
        }
      }

      initInterestData
        .filter(e => settingStore.activeProductId === e.productId)
        .forEach((interest) => {
          if (interest.bonus) {
            const {latestYearBonusRate, latestEndBonusRate } = curProductInterestData.bonusRateData || {}
            const targetBonusCustomRateProps = [
                latestYearBonusRate != null ? 'yearBonusRate' : null,
                latestEndBonusRate != null ? 'endBonusRate' : null
              ].filter(it => it != null)
            if (curProductInterestData.bonusRateFlag) {
              const bounsItem = {
                key: 'bonus',
                stat: 'lyfhqh',
                name: '分红',
                options: interest.bonus.opts,
              }
              vm.addBonusCustomRateToBonusItem(bounsItem)

              formItems.push(bounsItem)

            } else {
              formItems.push({
                key: 'bonus',
                stat: 'lyfhqh',
                name: '分红',
                options: interest.bonus.opts
              })
            }
            // if (initResultData.interestSetting) {
            //   const settingForm =
            //     initResultData.interestSetting.productFormList.find(
            //       (p) => p.productId === curProductFormData.productId
            //     );
            //   if (settingForm) {
            //     curProductFormData.formValues.bonus = settingForm.formValues.bonus;
            //   }
            // }
          }
          const _takeTypeOptsLength = (_get(interest, 'takeType.opts') || []).filter(o => !o.hiddenFlag).length
          if (_takeTypeOptsLength > 1) {
            formItems.push({
              key: 'takeType',
              stat: 'lqfs',
              name: '当年领取',
              options: _get(interest, 'takeType.opts')
            })
          }
          if (interest && interest.bonusTake) {
            const _bonusTakeOpts = (interest.bonusTake.opts || []).filter(o => !o.hiddenFlag)
            if (_bonusTakeOpts.length > 1) {
              const bonusTakeItem={
                key: 'bonusTake',
                stat: 'hllqfs',
                name: '红利领取',
                options: _get(interest, 'bonusTake.opts')
              }
              vm.addBonusTakeAccRate(bonusTakeItem)
              formItems.push(bonusTakeItem)
            }
          }
          if (interest && interest.pensionTake) {
            const _pensionTakeOpts = (interest.pensionTake.opts || []).filter(o => !o.hiddenFlag)
            if (_pensionTakeOpts.length > 1) {
              const pensionTakeItem={
                key: 'pensionTake',
                stat: 'njlqfs',
                name: '年金领取',
                options: _get(interest, 'pensionTake.opts')
              }
              vm.addPensionTakeItem(pensionTakeItem)
              formItems.push(pensionTakeItem)
            }
          }
          if (interest.rate) {
            const options = cloneDeep(interest.rate.opts).map((o, i) => ({
              ...o,
              index: i
            }))
            let customRateOption = false
            if (options && options.length) {
              options.forEach((o, i) => {
                // 服务端逻辑（By ZXY）：账户利益选项是依次：保证、中档、高档、假定利率。即 3 一定是对应假定利率
                if (i === 3) {
                  o.value = curProductFormData.customRate || o.value
                }
                o.description = `${o.description} ${(o.value * 100).toFixed(2)}%`;
                if (o.description.search(/\$/) !== -1) {
                  o.description = `${o.description.replace('$', '')}`;
                }
              })
              customRateOption = options.find(o => o.index === 3)
              if (customRateOption) {
                // 当假定利率的值已存在，隐藏假定利率选项。From hyw
                customRateOption.hiddenFlag = options.filter(e => e.value === customRateOption.value).length > 1
              }
            }
            const _accountRateHistoryList = _get(curProductInterestData, 'accountRateHistoryList') || []
            const actionBtnTx = customRateOption ? '设置利率' : (_accountRateHistoryList && _accountRateHistoryList.length) ? '历史利率' : ''
            formItems.push({
              key: 'rate',
              stat: 'lyllqh',
              name: '账户利率',
              hasCustomRate: !!customRateOption,
              actionBtnTx,
              options
            })
          }
        })
      return ['activeProductId', 'bonus', 'drawData', 'takeType', 'bonusTake', 'pensionTake', 'rate', 'addAndTakeData','displayAge'].map(k => formItems.find(e => e.key === k)).filter(e => !!e)
    },
    interestFieldOptions () {
      const { interestDetailData, interestDemoOptions, curProductFormData } = this
      if (!interestDetailData) {
        return []
      }
      const userShowInterestKeyList = interestDetailData.filter(e => e.userShow).map(e => e.key)
      const formItems = interestDemoOptions.filter(e => e.key !== 'activeProductId')
      formItems.push({
        key: 'displayFields',
        stat: 'lyxsxsxzdxx',
        name: '保单利益（选择转发后可见的展示项目-多选）',
        options: interestDetailData.map(e => ({
          value: e.key,
          description: e.name || e.key
        })).filter(e => userShowInterestKeyList.length ? userShowInterestKeyList.includes(e.value) : !NONMAIN_CALCULATION_FIELDS.includes(e.value)),
        _nonmainCalculationFields: NONMAIN_CALCULATION_FIELDS
      })
      formItems.push({
        key: 'singleCalType',
        stat: 'dlsf',
        name: '单利算法',
        options: [],
        actionBtnTx: `算法${_get(curProductFormData, 'formValues.singleCalType') || ''}`
      })
      return formItems
    }
  },
  watch: {
    isShowInterestForm: {
      handler (val) {
        this.$emit('has-interest-demo', val)
      },
      immediate: true
    }
  },
  async created () {
    const self = this
    await self.initInterest()
    if (location.hash === '#interestDemo') {
      setTimeout(() => {
        const interestDemo = document.querySelector(location.hash)
        if (interestDemo) {
          interestDemo.scrollIntoView()
        }
      }, 2000)
    }
  },
  methods: {
    initInterest () {
      const { initResultData, params } = this
      return initInterest({
        uuid: params.uuid
      }, pbType === 'annual_survey')
        .then((res) => {
          const { success, data, code } = res.data
          this.isCaseInterestData = code === '015001'
          if (this.isCaseInterestData) {
            return Promise.resolve()
          }
          if (!(success && data && data.length)) {
            this.$emit('set-interest-key', [])
            this.$emit('has-interest-demo', false)
            this.$emit('has-bonus', false)
            return
          }
          data.forEach(item => {
            const keys = ['bonusTake', 'pensionTake']
            keys.forEach(k => {
              const _options = (_get(item, `${k}.opts`) || []).filter(o => !o.hiddenFlag)
              /**
              * 红利领取、年金领取选项展示规则 @hyw https://devops.aliyun.com/projex/project/be137710be12b4398cd7fb7674/req/f7f3292695e5d78953770e9388
              */
              const curProduct = (_get(initResultData, 'resultData.productGroupList[0].prodOrderList') || []).find(p => p.key === item.productId)
              const hasAccount = curProduct ? (_get(curProduct, 'mulInsOrderList') || []).some(ins => ins.account) : false // 是否搭配万能账户
              let opt = []
              if(k === 'bonusTake') {
                if (hasAccount) {
                  if (_options.find(o => o.value === 'bonus_account')) {
                    opt = _options.filter(o => o.value === 'bonus_account')
                  }else {
                    opt = _options
                  }
                }else {
                  opt = _options.filter(o => o.value !== 'bonus_account')
                }
              }
              if(k === 'pensionTake') {
                if (hasAccount) {
                  if (_options.find(o => o.value === 'annuity_account')) {
                    opt = _options.filter(o => o.value === 'annuity_account')
                  }else {
                    opt = _options
                  }
                }else {
                  opt = _options.filter(o => o.value !== 'annuity_account')
                }
              }
              if(item[k]) {
                item[k].opts = opt
                if (opt.length && !item[k].value) {
                  item[k].value = _get(opt, '[0].value')
                }
              }
            })

            // 如果分红中没有中档选项，则不显示红利实现率。From hyw
            const bonusOptions = _get(item, 'bonus.opts') || []
            const midOption = bonusOptions.find(o => o.value === 'mid' && !o.hiddenFlag)
            if(!midOption && item.bonusRateFlag) {
              item.bonusRateFlag = false
            }
          })
          console.log('---', data);
          this.settingStore = initSettingStore(data, initResultData)
          this.initInterestData = data
          this.getInterestDetail()
          this.$emit('set-interest-key', this.getInterestKey(data))
          this.$emit('has-interest-demo', this.isShowInterestForm)
          // 分红险：initInterest 返回数据中任意一项 bonus 有值即为有分红险
          this.$emit('has-bonus', data.some(item => !!item.bonus))
        }).catch(() => {
          this.$emit('set-interest-key', [])
          this.$emit('has-interest-demo', false)
          this.$emit('has-bonus', false)
        })
    },
    getInterestKey (data) {
      const keys = []
      data.filter(pd => Array.isArray(pd.data)).forEach(pd => {
        pd.data.forEach(({ key }) => {
          if (keys.indexOf(key) < 0) {
            keys.push(key)
          }
        })
      })
      return keys
    },
    async getInterestDetail () {
      const self = this
      const { params, settingStore, curProductFormData, curProductInterestData } = self
      const { drawInsuranceId, accountInsuranceId, customRate, addAndTakeData, drawData, duplicateDrawData, formValues } = curProductFormData
      const { bonus, takeType, bonusTake, pensionTake, rate, rateIndex, drawFlag, addAndTakeFlag, hideFieldsForClient, endBonusRate, yearBonusRate, singleCalType, accRate, bonusCustomRate } = formValues
      const mainInsuranceId = _get(curProductInterestData, 'insuranceId')
      const reqParams = {
        uuid: params.uuid,
        productId: settingStore.activeProductId,
        mainInsuranceId,
        insuranceInterestFlag: !!mainInsuranceId,
        drawInsuranceId,
        accountInsuranceId,
        bonus: {
          value: bonus
        },
        takeType: {
          value: takeType
        },
        bonusTake: {
          value: bonusTake
        },
        pensionTake: {
          value: pensionTake
        },
        rate: {
          value: rateIndex === -1 ? customRate : rate
        },
        addAndTakeData: addAndTakeData ? addAndTakeData.addAndTakeData : null,
        addAndTakeFlag,
        drawData,
        duplicateDrawData,
        accRate,
        drawFlag,
        endBonusRate,
        yearBonusRate,
        bonusRealRate: bonusCustomRate || bonusCustomRate === 0 ? parseFloat((bonusCustomRate / 100).toFixed(2)) : null,
        singleCalType
      }
      const { bonusCustomRateContext } = self.interestDemoOptions.find(it => it.key === 'bonus') || {}
      let effectiveBonusCustomRate = null
      const formItems = self.interestDemoOptions.filter(e => e.key !== 'activeProductId')
      const bonusItem = formItems.find(item => item.key === 'bonus')
      if (formValues.bonus === BONUS_PSUDO_OPTION_CUSTOM_RATE.value) {
        if (bonusItem) {
          self.addBonusCustomRateToBonusItem(bonusItem)
        }
        effectiveBonusCustomRate = self.percentToFractional(formValues.bonusCustomRate)
        effectiveBonusCustomRate = effectiveBonusCustomRate != null ? effectiveBonusCustomRate : (bonusCustomRateContext && self.percentToFractional(bonusCustomRateContext.latest))
        // Caution: 因为 UI 上将选项平铺，做了"仅有 mid （中档分红）才附加红利实现率" 的假设与约定。
        reqParams.bonus = { value: 'mid'}
      } else {
        reqParams.bonus = { value: formValues.bonus }
        reqParams.bonusRealRate = null
      }

      if (bonusCustomRateContext && bonusCustomRateContext.targetBonusCustomRateProps) {
        bonusCustomRateContext.targetBonusCustomRateProps.forEach(propName => {
          reqParams[propName] = effectiveBonusCustomRate
        })
      }

      this.interestDetailRequestParams = cloneDeep(reqParams)
      const cacheKey = QS.stringify(reqParams)
      const cacheData = CACHE_DETAIL_DATA_WITH_REMARK[cacheKey]
      if (cacheData) {
        self.interestDetailData = cacheData.dataList
        self.interestDetailWithRemark = cacheData
      } else {
        self.interestDetailData = await getInterestDetailWithRemark(reqParams, pbType === 'annual_survey').then((res) => {
          const { code, success, data, info } = res.data
          self.isCaseInterestData = code === '015001'
          if (self.isCaseInterestData) {
            return Promise.resolve()
          }
          if (!(success && data)) {
            this.$toast(info || '接口异常')
            return Promise.reject()
          }
          if (data.dataList) {
            data.dataList.forEach(d => {
              if (['irr_value', 'single_value', 'policy_cash_grow_rate', 'annuity_year_per_baof'].includes(d.key)) {
                return
              }
              if (d.values) {
                d.values = d.values.map(v => v ? Math.round(v) : v)
              }
            })
          }

          // WYJHS-4220:【线上复盘问题解决】利益为空，新增埋点。From hyw
          const dataList = _get(data, 'dataList') || []
          if (!dataList.some(e => (e.values || []).length)) {
            window.WeiyiStatSDK && window.WeiyiStatSDK.submit('JHS_JGY_LYBCZ', {
              uuid: params.uuid,
              productId: settingStore.activeProductId,
            })
          }
          self.interestDetailWithRemark = data
          CACHE_DETAIL_DATA_WITH_REMARK[cacheKey] = data
          return Promise.resolve(data.dataList)
        })
      }

      self.interestDetailData = self.interestDetailData.filter(e => isBxs || isNuoYa || !(hideFieldsForClient && hideFieldsForClient.includes(e.key)))

      // 没有默认字段，默认选中所有。From hyw
      const hasPbResultShow = self.interestDetailData.some(e => e.pbResultShow)
      const hasUserShow = self.interestDetailData.some(e => e.userShow)
      if (!_get(formValues, 'displayFields.length')) {
        formValues.displayFields = self.interestDetailData.filter(e => hasPbResultShow ? e.pbResultShow : true).map(e => e.key)
      }
      // 所有字段的 hasUserShow 都为 false，以下利益字段不显示。From hyw
      if (_get(formValues, 'displayFields.length') && !hasUserShow) {
        formValues.displayFields = formValues.displayFields.filter(k => !NONMAIN_CALCULATION_FIELDS.includes(k))
      }
      // 以下字段，如果存在，必需显示。From hyw
      const fileds = ['take', 'add', 'draw_year']
      fileds.forEach(k => {
        if (!(formValues.displayFields || []).includes(k) && self.interestDetailData.find(e => e.key === k)) {
          formValues.displayFields.push(k)
        }
      })
      this.commitInterestData()
    },
    update(data = {}) {
      const { settingStore } = this
      let isNeedSendRequest = false
      Object.keys(data).forEach(k => {
        if (Object.keys(settingStore).includes(k)) {
          settingStore[k] = data[k]
        }
        const currentProduct = settingStore.productFormList.find(p => p.productId === settingStore.activeProductId)
        if (Object.keys(currentProduct).includes(k)) {
          currentProduct[k] = data[k]
        } else if (Object.keys(currentProduct.formValues).includes(k)) {
          currentProduct.formValues[k] = data[k]
        }
        if (!['displayType', 'displayFields', 'displayAge', 'hideFieldsForClient'].includes(k)) {
          isNeedSendRequest = true
        }
      })
      if (isNeedSendRequest) {
        this.getInterestDetail()
      }
      if (this.syncDelta) {
        this.syncDelta({ pbData: { interestDemoV2Setting: data } })
      }
      this.commitInterestData()
    },
    commitInterestData () {
      const { curProductResultData, curProductFormData, curProductInterestData, interestFieldOptions, interestDetailWithRemark } = this
      this.$store.commit('SET_INTEREST_DATA', {
        curProductResultData,
        curProductFormData,
        curProductInterestData,
        interestFieldOptions,
        interestDetailWithRemark
      })
    },
    save () {
      // type： 0-按resultUuid存配置 1-按planbookId存配置
      const { params, settingStore } = this
      const cpStore = cloneDeep(settingStore)
      if (cpStore.productFormList) {
        cpStore.productFormList.forEach(p => {
          if (p.addAndTakeData) {
            p.addAndTakeData = p.addAndTakeData.addAndTakeData
          }
          // 不再保存自定义利率、设置浮层的状态。From hyw
          if (p.formValues) {
            p.formValues.isShowFieldPopup = false
            p.formValues.isShowRatePopup = false
          }
        })
      }
      return saveShareInteraction({
        resultUuid: params.uuid,
        interestSetting: cpStore
      }).then(res => {
        const { success, data } = res.data
        if (!success || !data) {
          return Promise.resolve()
        }
        return Promise.resolve(data)
      })
    },
    onOpenAddAndTake (item) {
      const interestSettingPopupsComp = this.$refs.interestSettingPopups
      if (interestSettingPopupsComp && typeof interestSettingPopupsComp.openAddAndTakePicker === 'function') {
        interestSettingPopupsComp.openAddAndTakePicker(item)
      }
    },
    fractionalToPercent(num, digits = 0) {
      if (!num && num !== 0) {
        return null
      }
      const rawNum = Number(num)
      if (Number.isNaN(rawNum)) {
        return null
      }
      return Number((rawNum * 100).toFixed(digits))
    },
    percentToFractional(percent, digits = 2) {
      if (!percent && percent !== 0) {
        return null
      }
      const rawNum = Number(percent)
      if (Number.isNaN(rawNum)) {
        return null
      }
      return Number((rawNum / 100).toFixed(digits))
    },
    addBonusCustomRateToBonusItem(bonusItem) {
      const { curProductResultData, curProductFormData, curProductInterestData } = this
      const {latestYearBonusRate, highestYearBonusRate, latestEndBonusRate, highestEndBonusRate, highestCompanyBonusRate,bonusRateList, companyBonusRateList } = curProductInterestData.bonusRateData || {}
      const targetBonusCustomRateProps = [
        latestYearBonusRate != null ? 'yearBonusRate' : null,
        latestEndBonusRate != null ? 'endBonusRate' : null
      ].filter(it => it != null)
      // 红利实现率显示逻辑改为bonusRateFlag == true显示 @向宇
      if (!bonusItem || !curProductResultData || !curProductInterestData.bonusRateFlag) {
        return
      }
      bonusItem.bonusCustomRateContext = {
        // 优先最近年度实现率，其次最近终了实现率。不关心当前产品还是同公司。 改版后最近的值统一改成 100
        latest: this.fractionalToPercent(latestYearBonusRate != null ? latestYearBonusRate : latestEndBonusRate),
        // lasest: 100,
        // 年度 vs 终了，取高
        highest: Math.max(this.fractionalToPercent(highestYearBonusRate || 0), this.fractionalToPercent(highestEndBonusRate || 0)),
        highestCompany: this.fractionalToPercent(highestCompanyBonusRate || 0),
        targetBonusCustomRateProps,
        bonusRateHistory: {
          bonusRateList,
          companyBonusRateList,
          companyName: curProductResultData.companyName
        }
      }
      // formValues.yearBonusRate / endBonusRate 分别是分红中 年度（可能为现金型或保额型）/终了 红利实现率的'假定利率'
      const { formValues } = curProductFormData

      const { yearBonusRate, endBonusRate } = formValues
      const bonusCustomRate = this.fractionalToPercent(latestYearBonusRate != null ? yearBonusRate : endBonusRate)
      // 缺省值为'官网最近红利实现率'，选中'假定利率'选项即填充
      const displayBonusCustomRate = bonusCustomRate != null ? Number(bonusCustomRate) : 100

      formValues.maxBonusCustomRate = Math.max(bonusItem.bonusCustomRateContext.highestCompany, 100)

      if (formValues.bonusCustomRate == null) {
        formValues.bonusCustomRate = displayBonusCustomRate
        const newOption = { ...BONUS_PSUDO_OPTION_CUSTOM_RATE, description: `红利实现率 ${formValues.bonusCustomRate}%` };
        const optionExists = bonusItem.options.findIndex(option => option.value === newOption.value);
        if (optionExists === -1) {
          bonusItem.options.push(newOption);
        }else {
          bonusItem.options.splice(optionExists, 1, newOption);
        }
        if (bonusCustomRate != null) {
          formValues.bonus = BONUS_PSUDO_OPTION_CUSTOM_RATE.value
        }
      } else {
        let option = bonusItem.options.find(item => item.value === BONUS_PSUDO_OPTION_CUSTOM_RATE.value)
        if (option) {
          option.description = `红利实现率 ${Number(formValues.bonusCustomRate)>200 ? 200 : Number(formValues.bonusCustomRate)}%`
        }else {
          const newOption = { ...BONUS_PSUDO_OPTION_CUSTOM_RATE, description: `红利实现率 ${Number(formValues.bonusCustomRate)}%` };
          bonusItem.options.push(newOption);
        }
      }
    },
    addBonusTakeAccRate(bonusTakeItem){
      const {  curProductFormData } = this
      const { formValues } = curProductFormData
      if (formValues.accRate !== null) {
        let option = bonusTakeItem.options.find(item => item.value === "bonus_acc")
        if (option) {
          option.description = `累积生息 ${Number((formValues.accRate*100).toFixed(2))}%`
        }
      }
    },
    addPensionTakeItem(pensionTakeItem){
      const {  curProductFormData } = this
      const { formValues } = curProductFormData
      if (formValues.accRate !== null) {
        let option = pensionTakeItem.options.find(item => item.value === "annuity_acc")
        if (option) {
          option.description = `累积生息 ${Number((formValues.accRate*100).toFixed(2))}%`
        }
      }
    },
    hideBonus(value){
      const {formValues} = this.curProductFormData
      const formItems = this.interestDemoOptions.filter(e => e.key !== 'activeProductId')
      const bonusItem = formItems.find(item => item.key === 'bonus')
      if (bonusItem) {
        if(bonusItem.options && bonusItem.options.length > 0 && !value && this.isFirstVisit&&formValues.bonus!=='low'){
          const midItem = bonusItem.options.find(item => item.value === "mid")
          formValues.bonus = !!midItem ? midItem.value : bonusItem.options[0].value;
          this.isFirstVisit = false;
        }
      }
    }
  }
}
</script>
<style>
@import './index.css';
</style>
